import { kCLSize } from "../constants";
import { QConnectingLine } from "./QConnectingLine";
import { QElement } from "./QElement";
import { QElementGroup } from "./QElementGroup";

export class QConnectingLineGroup extends QElementGroup {
  constructor() {
    super();
    this.fLayout = null;
    this.fDataObj = null;
    this.fParentPanel = null;
    this.fPageMgr = null;
  }

  InitConnectingLineGroup(theLayout, dataObj, parentPanel) {
    this.fLayout = theLayout;
    this.fDataObj = dataObj;
    this.fParentPanel = parentPanel;
    this.InitGroup();
  }

  SetLayout(theLayout) {
    this.fLayout = theLayout;
  }

  GetLayout() {
    return this.fLayout;
  }

  GetDataObj() {
    return this.fDataObj;
  }

  AddConnector(xs, ys, xe, ye, layoutList) {
    var connectingLine = new QConnectingLine();
    connectingLine.InitConnectingLine(this, this.fParentPanel, layoutList);
    var h = kCLSize / 2;

    var xPos, yPos;
    var width, height;
    var horizontal;
    if (ys == ye) {
      xPos = xs; // +h;
      yPos = ys - h;
      width = xe - xs; // -kCLSize;
      height = kCLSize;
      horizontal = true;
    } else {
      xPos = xs - h;
      yPos = ys; // +h;
      width = kCLSize;
      height = ye - ys; // -kCLSize;
      horizontal = false;
    }

    connectingLine.fOffsetX = xPos;
    connectingLine.fOffsetY = yPos;

    //connectingLine.PositionElement(xPos,yPos);
    connectingLine.SizeElement(width, height);
    connectingLine.SetOrientation(horizontal);
    this.AddALine(connectingLine);
  }

  AddALine(connectingLine) {
    connectingLine.SetElementGroup(this);

    var l = this.GetLayout();
    var lineLayer = l.GetLayer();
    connectingLine.SetLayer(lineLayer);

    this.fParentPanel.PushElement(connectingLine);
  }

  //======================================================================
  InitConnectingLines(pageMgr, nodeRef) {
    this.ClearGroup(this.fParentPanel, null);

    //	var dataObj = this.GetDataObj();
    //	var numChildren = dataObj.GetNumChildren();
    //	if (numChildren == 0)
    //		return;
    this.fPageMgr = pageMgr;

    var nodeLines = nodeRef.GetChildLines();
    if (nodeLines == null) return;

    var n = nodeLines.length;
    for (var i = 0; i < n; i++) {
      var nodeLine = nodeLines[i];
      var layoutList = nodeLine.GetAssociatedLayouts();
      this.AddConnector(
        nodeLine.fLeft,
        nodeLine.fTop,
        nodeLine.fRight,
        nodeLine.fBottom,
        layoutList
      );
    }
  }

  SetConnectingLineThickness(thickness) {
    this.fLayout.SetConnectingLineThickness(thickness);
  }

  GetConnectingLineThickness() {
    return this.fLayout.GetConnectingLineThickness();
  }

  SetConnectingLineColor(lineColor) {
    this.fLayout.SetConnectingLineColor(lineColor);
  }

  GetConnectingLineColor() {
    return this.fLayout.GetConnectingLineColor();
  }

  SetConnectingLineFillMode(fillMode) {
    this.fLayout.SetConnectingLineFillMode(fillMode);
  }

  GetConnectingLineFillMode() {
    return this.fLayout.GetConnectingLineFillMode();
  }

  SetConnectorDashStyle(dashStyle) {
    this.fLayout.SetConnectorDashStyle(dashStyle);
  }

  GetConnectorDashStyle() {
    return this.fLayout.GetConnectorDashStyle();
  }
}
